module.exports = __webpack_public_path__ + "img/q50-2025.56319c82.png";